import styled from 'styled-components'
import { StyledDetailWrapper } from '~/components/Exchange/styled'

export const Container = styled(StyledDetailWrapper)`
  .tooltip-wrap img {
    margin-left: 0;
  }
`

export const StyledLabel = styled.span`
  margin-right: 4px;
`

export const StyledGreenShield = styled.img`
  width: 14px;
  height: 16px;
  cursor: pointer;
`
